/**
 * 兼容旧系统的函数
 *
 * @Author: Shann
 * @LastEditors: Shann
 * @Date: 2021-04-07 17:05:39
 * @LastEditTime: 2021-04-13 17:48:10
 * @FilePath: \buyer-one\dop-webapp\src\utils\compatible.js
 */

const zh = require("../locales/dict/zh.js").default;
const en = require("../locales/dict/en.js").default;
const ru = require("../locales/dict/ru.js").default;
const Lang = require("../components/Lang/Lang").default;
const Locale = require("./locale").default;

let locale = Locale.current();
let dict = null;

switch (locale) {
    case "en":
        dict = en;
        break;
    case "ru":
        dict = ru;
        break;
    default:
        dict = zh;
        break;
}

let find = function (dict, codeArray, itemCode) {
    for (let i = 0, k = dict[codeArray[0]].s.length; i < k; i++) {
        if (dict[codeArray[0]].s[i].c === codeArray[1]) {
            return dict[codeArray[0]].s[i];
        }
    }
    return itemCode;
};

let condition = function (itemCode) {
    if (!itemCode) {
        return itemCode;
    }
    let codeArray = itemCode.split(".");
    if (codeArray.length !== 2) {
        return itemCode;
    }
    if (!dict[codeArray[0]]) {
        return itemCode;
    }
    if (dict[codeArray[0]].s.length === 0) {
        return itemCode;
    }
    return codeArray;
};

let __getDictMap = function (categoryCode) {
    let list = dict[categoryCode] ? dict[categoryCode].s : [];
    let map = {};
    for (let i in list) {
        map[list[i].c] = list[i].n;
    }
    return map;
};

let __getServerDictCategory = function (categoryCode) {
    if (!categoryCode) {
        return categoryCode;
    }
    if (!dict[categoryCode]) {
        return categoryCode;
    }
    return dict[categoryCode];
};

let __getServerDict = function () {
    return dict;
};

let __getServerDictItem = function (itemCode) {
    let codeArray = condition(itemCode);
    if (codeArray === itemCode) {
        return itemCode;
    }
    return find(dict, codeArray, itemCode).n || itemCode;
};

let __getServerDictItemObject = function (itemCode) {
    let codeArray = condition(itemCode);
    if (codeArray === itemCode) {
        return itemCode;
    }
    return find(dict, codeArray, itemCode);
};

//获取字典列表（重新封装返回格式）
let __getDictList = function (dictName) {
    let _dictResult = __getServerDictCategory(dictName);
    let _itemList = [];

    //处理字典返回异常的情况
    if (typeof _dictResult == "string") {
        _dictResult = [];
    }

    /**
     * 容错判断
     * by ccw
     */
    if (_dictResult.s) {
        //转化原始字典格式
        for (let i = 0; i < _dictResult.s.length; i++) {
            let _result = _dictResult.s[i];
            let _item = {
                id: _result.i,
                code: _result.c,
                name: _result.n,
                remark: _result.u,
            };
            _itemList.push(_item);
        }
    }

    return _itemList;
};

let __getServerLanguage = function (code) {
    let slice = Array.prototype.slice;
    code = slice.call(arguments, 0, 1)[0];
    return Lang({ id: code, params: slice.call(arguments, 1) })||code;
};

module.exports = {
    __getServerDictCategory,
    __getServerDict,
    __getServerDictItem,
    __getServerDictItemObject,
    __getDictList,
    __getServerLanguage,
    __getDictMap,
};
